<template>
    <div>
        <SpeqDashboardSuperAdmin v-if="user.role.id == 1 || user.role.id == 4 || user.role.id == 5" />
        <SpeqDashboardCommon v-else />
    </div>
</template>

<script>
import {computed, onMounted} from 'vue';
import {useStore} from "vuex";

import SpeqDashboardSuperAdmin from '@/components/speq/SpeqDashboardSuperAdmin.vue'
import SpeqDashboardCommon from '@/components/speq/SpeqDashboardCommon.vue'

export default {
    props: [],
	emits: [],
	components: {
        SpeqDashboardSuperAdmin,
        SpeqDashboardCommon
	},
    setup(){
        const store = useStore();

        let user = computed(function () { return store.state.user });

		onMounted(() => {
            
		});

		return {
            user
		}
	},
	data() {
		return {
            orders:[
                {
                    id: 1,
                    name: ''
                },
            ],
            paginatedOrders: [],
            perPage: 5,
		}
	},
    mounted() {
        
    },
	methods: {
		updateRow(val) {
            this.paginatedOrders = val;
        }
	}
}
</script>